import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

const LABELS = { admin: "Administrateur", member: "Sans accès" };

export const UsersTab = ({ call }) => {
  const [data, setData] = useState({ roles: [], users: [] });
  const load = () => call("get", "/users").then(setData).catch(() => {});
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const change = async (uid, role) => {
    try { await call("patch", `/users/${uid}/role`, { role }); toast.success("Rôle modifié"); } catch { /* toast shown */ }
    load();
  };

  return (
    <ul className="space-y-3" data-testid="admin-users-list">
      {data.users.map((u) => (
        <li key={u.user_id} className="flex flex-wrap items-center gap-3 rounded-[20px] bg-white p-3 shadow-sm" data-testid={`admin-user-${u.user_id}`}>
          <span className="flex-1 truncate font-semibold">{u.email || u.user_id}</span>
          <Select value={u.role} onValueChange={(r) => change(u.user_id, r)}>
            <SelectTrigger className="w-44" data-testid={`admin-user-role-${u.user_id}`}><SelectValue /></SelectTrigger>
            <SelectContent>{data.roles.map((r) => <SelectItem key={r} value={r}>{LABELS[r] || r}</SelectItem>)}</SelectContent>
          </Select>
        </li>
      ))}
    </ul>
  );
};
